import { createBarStore } from './createBarStore';

export interface GiftRegistryBarState {
  archived: boolean;
  /** '' = gifts and requests. */
  kind: string;
  /** '' = any priority. */
  priority: string;
  layout: 'list' | 'cards';
  /** The open item (item page). */
  editor: { canEdit: boolean; isNew: boolean; archived: boolean; dirty: boolean; saving: boolean };
}

export const NO_GIFT_EDITOR: GiftRegistryBarState['editor'] = { canEdit: false, isNew: false, archived: false, dirty: false, saving: false };

const store = createBarStore<GiftRegistryBarState>({ archived: false, kind: '', priority: '', layout: 'list', editor: NO_GIFT_EDITOR });

export const getGiftRegistryBar = store.get;
export const setGiftRegistryBar = store.set;
export const resetGiftRegistryBar = store.reset;
export const useGiftRegistryBar = store.use;

/** Bar -> list. */
export const GIFT_NEW_EVENT = 'gift-registry:new';
export const GIFT_SHARE_EVENT = 'gift-registry:share';
/** Bar -> item page. Save and Delete reuse the app's generic form events (form-save, form-delete). */
export const GIFT_RESTORE_EVENT = 'gift-item:restore';
export const GIFT_FOREVER_EVENT = 'gift-item:delete-forever';
